import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card.js';

export default function AlDashboard(props) {
  return (
    <Card p='20px' align='center' direction='column' w='100%' h={'calc(100vh - 200px)'}>
    </Card>
  );
}
